// extracted by mini-css-extract-plugin
module.exports = {"root":"CellDataContainer_root__3VeUw"};